<div class="container">
  <div class="all">
      <div class="tests">
            <table style="width:100%">
              <tr class="back">
                <th>Patient Name</th>
                <th>Bill date</th>
                <th>Reg No.</th>
                <th>Total Amount</th>
                <th>Paid</th>
              </tr>
              <tr class="td" *ngFor="let item of encounters" style="cursor: pointer;" (click)="getSamples(item.Bill_ID)">
                <td>{{item.patientName}}</td>
                <td>{{item.billDate | date}}</td>
                <td>{{item.registration_no}}</td>
                <td>{{item.totalAmount | currency:'&#8358;'}}</td>
                <td>{{item.Recd_Payment}}</td>
                <!-- <td *ngIf="!item.Recd_Payt">No</td> -->
              </tr>
            </table>
            <div *ngIf="isLoading" style="margin-top: 200px;" class="spinner">
              <mat-spinner></mat-spinner>
            </div>
      </div>

  </div>
</div>
